// material-ui
import { Theme } from '@mui/material/styles';

// ==============================|| OVERRIDES - TAB ||============================== //

export default function Scrollbar(theme: Theme) {
  return {
    MuiCssBaseline: {
      styleOverrides: {
        '::-webkit-scrollbar': {
          width: '8px',
          height: '6px'
        },
        '::-webkit-scrollbar-track': {
          borderRadius: '3px',
          backgroundColor: 'transparent'
        },
        '::-webkit-scrollbar-thumb': {
          background: theme.palette.mode === 'light' ? theme.palette.grey['300'] : theme.palette.grey['800'],
          borderRadius: '3px'
        },
        '::-webkit-scrollbar-thumb:hover': {
          background: theme.palette.mode === 'light' ? theme.palette.grey['500'] : theme.palette.grey['700']
        },
        scrollbarWidth: 'thin',
        scrollbarGutter: 'stable'
      }
    }
  };
}
